import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
  useToast,
} from "@chakra-ui/react";
import { crm } from "../../../theme";
import { useState } from "react";
import { ProcessViewModel } from "../../../models/Process";
import { deleteProcess } from "../../../services/processService";

interface DeleteProcessModalProps {
  isOpen: boolean;
  onClose: () => void;
  process?: ProcessViewModel;
  onDeleted: () => void;
}

const DeleteProcessModal = ({
  isOpen,
  onClose,
  process,
  onDeleted,
}: DeleteProcessModalProps) => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleClose = () => {
    setReason("");
    onClose();
  };

  const handleConfirm = async () => {
    if (!process?.id) return;

    if (!reason.trim()) {
      toast({
        title: "Informe o motivo da exclusão",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    try {
      const response = await deleteProcess(process.id, reason.trim());
      if (response?.success) {
        toast({
          title: "Processo excluído com sucesso",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
        handleClose();
        onDeleted();
      } else {
        toast({
          title: response?.notifications?.[0] ?? "Erro ao excluir processo",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch {
      toast({
        title: "Erro ao excluir processo",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay backdropFilter="blur(2px)" bg="blackAlpha.600" />
      <ModalContent borderRadius="16px" boxShadow="0 12px 32px rgba(16,24,40,0.18)">
        <ModalHeader borderBottom={crm.border}>Excluir processo</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb="16px">
            Tem certeza que deseja excluir o processo{" "}
            <strong>{process?.cvfRef}</strong>? Esta ação não pode ser desfeita
            pela interface.
          </Text>
          <FormControl isRequired>
            <FormLabel>Motivo da exclusão</FormLabel>
            <Textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Descreva o motivo da exclusão"
              rows={4}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter gap="8px" borderTop={crm.border}>
          <Button variant="outline" borderColor={crm.border} color={crm.text} borderRadius="10px" onClick={handleClose} isDisabled={loading}>
            Cancelar
          </Button>
          <Button
            backgroundColor={crm.danger}
            _hover={{ backgroundColor: "red.600" }}
            color="white"
            borderRadius="10px"
            onClick={handleConfirm}
            isLoading={loading}
          >
            Excluir processo
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteProcessModal;
